import { addDays, getDate, isSaturday, isSunday, isToday } from 'date-fns'
import { sortedLastIndexBy } from 'lodash'
import theme from '../theme/theme'
import { IDimensions } from '../utils/Canvas'
import roundedRect from './roundedRect'

export default (
  ctx: CanvasRenderingContext2D,
  constants: IDimensions,
  cWidth: number,
  startDay: Date,
  scrollLeft: number,
  selectedDates: Date[],
  formatDate,
) => {
  let dayCounter = 0
  const currentDate = new Date()

  ctx.fillStyle = theme.colors.calendar.gridBorder
  ctx.fillRect(0, constants.HEADER_HEIGHT, cWidth, constants.GRID_BORDER_WIDTH)

  const roundedHalfHeight = Math.round(constants.HEADER_HEIGHT / 2)
  const roundedHalfWidth = Math.round(constants.GRID_WIDTH / 2)
  for (
    let basei = 0;
    basei < cWidth + constants.GRID_WIDTH;
    basei += constants.GRID_WIDTH
  ) {
    const day = addDays(startDay, dayCounter)
    const opacity = day < currentDate ? '0.5' : '1'
    const i = basei
    ctx.fillStyle = theme.colors.palette.white
    ctx.fillRect(i, 0, constants.GRID_WIDTH, constants.HEADER_HEIGHT)
    ctx.fillStyle = theme.colors.calendar.gridBorder
    ctx.fillRect(i, 0, constants.GRID_BORDER_WIDTH, constants.HEADER_HEIGHT)
    if (isSaturday(day)) {
      ctx.fillRect(
        i + constants.GRID_BORDER_WIDTH,
        0,
        constants.HEADER_MARKED_DAY_BORDER,
        constants.HEADER_HEIGHT,
      )
    }
    if (isSunday(day)) {
      ctx.fillRect(
        i + constants.GRID_WIDTH - constants.HEADER_MARKED_DAY_BORDER,
        0,
        constants.HEADER_MARKED_DAY_BORDER,
        constants.HEADER_HEIGHT,
      )
    }
    const sortedDayIndex = sortedLastIndexBy(selectedDates, day, d =>
      d.getTime(),
    )
    if (
      sortedDayIndex &&
      selectedDates[sortedDayIndex - 1].getTime() === day.getTime()
    ) {
      ctx.fillStyle = theme.colors.header.selected
      roundedRect(
        ctx,
        i +
          Math.round(
            (constants.GRID_WIDTH - constants.HEADER_SELECTED_DAY_WIDTH) / 2,
          ),
        Math.round(
          (constants.HEADER_HEIGHT - constants.HEADER_SELECTED_DAY_HEIGHT) / 2,
        ),
        constants.HEADER_SELECTED_DAY_WIDTH,
        constants.HEADER_SELECTED_DAY_HEIGHT,
        4,
      )
    }
    const today = isToday(day)

    ctx.textAlign = 'center'
    ctx.font = `600 ${constants.HEADER_LABEL_FONT_SIZE}px Montserrat`
    ctx.fillStyle = today ? 'rgb(0,165,65)' : `rgba(105, 106, 109, ${opacity})`
    ctx.textBaseline = 'middle'
    ctx.fillText(
      formatDate(day).toUpperCase(),
      roundedHalfWidth + i,
      Math.round(
        roundedHalfHeight -
          constants.HEADER_LABEL_FONT_SIZE / 2 -
          constants.HEADER_TEXTS_PADDING,
      ),
    )
    ctx.textBaseline = 'middle'
    ctx.font = `600 ${constants.HEADER_DAY_FONT_SIZE}px Montserrat`
    ctx.fillStyle = today ? 'rgb(0,165,65)' : `rgba(39, 39, 40, ${opacity})`
    ctx.fillText(
      `${getDate(day)}`,
      roundedHalfWidth + i,
      Math.round(
        roundedHalfHeight +
          constants.HEADER_DAY_FONT_SIZE / 2 -
          constants.GRID_BORDER_WIDTH,
      ),
    )

    if (today) {
      ctx.fillStyle = theme.colors.primary
      ctx.fillRect(
        i,
        0,
        constants.HEADER_MARKED_DAY_BORDER + constants.GRID_BORDER_WIDTH,
        constants.HEADER_HEIGHT,
      )
    }

    dayCounter++
  }
}
